export const SUPPORTED_LOCALES = ["en", "uk"] as const;

export type AppLocale = (typeof SUPPORTED_LOCALES)[number];

const STORAGE_KEY = "nobori_locale";
const DEFAULT_LOCALE: AppLocale = "en";

let currentLocale: AppLocale = readInitialLocale();

export function normalizeLocale(value: unknown): AppLocale {
  const normalized = String(value ?? "")
    .trim()
    .toLowerCase()
    .replace("_", "-");

  if (normalized === "uk" || normalized.startsWith("uk-")) return "uk";
  if (normalized === "en" || normalized.startsWith("en-")) return "en";
  return DEFAULT_LOCALE;
}

export function getCurrentLocale(): AppLocale {
  return currentLocale;
}

export function setCurrentLocale(locale: AppLocale) {
  currentLocale = normalizeLocale(locale);

  if (typeof window !== "undefined") {
    window.localStorage.setItem(STORAGE_KEY, currentLocale);
  }

  if (typeof document !== "undefined") {
    document.documentElement.lang = currentLocale === "uk" ? "uk-UA" : "en-US";
  }
}

export function getLocaleStorageKey() {
  return STORAGE_KEY;
}

function readInitialLocale(): AppLocale {
  if (typeof window === "undefined") return DEFAULT_LOCALE;

  const stored = window.localStorage.getItem(STORAGE_KEY);
  if (stored) return normalizeLocale(stored);

  return normalizeLocale(window.navigator?.language);
}
